import React, { Component } from 'react';
import AWS from 'aws-sdk';
import './maindefinitions.css';
import './GrowerPage.css';


class GrowerPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      annualProduction: '',
	  areaCoffee: 0,
	  areaTotal: 0,
	  beangood: '',
	  certifications: '',
	  awards:'',
	  city_state: '',
	  country: '',
      elevation: '',
	  farmName: '',
      growerName:'',
      picture: '',
	  region: '',
	  textGrower_html: '',
      text_html: '',
      website: '',
      whyWeLikeIt: '',
    };

  //    this.handleChange = this.handleChange.bind(this);
  //    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {

    this.props.auth.currentCredentials()
      .then(credentials => {
        const dynamodb = new AWS.DynamoDB.DocumentClient({
          region: 'us-east-1',
          credentials: this.props.auth.essentialCredentials(credentials)
        });
        console.log('Farm ID: ', this.props.farmId);
        var params = {
          ExpressionAttributeValues: {
            ':id': this.props.farmId,
          },
          ExpressionAttributeNames: {
            '#id': 'farmId',
          },
          KeyConditionExpression: '#id = :id' ,
          TableName: 'Farms'
        };

        dynamodb.query(params, (err, data) => {
          if (err) {
            console.log(err);
            return null;
          } else {
            console.log('Read data from DynamoDB');
            console.log(data);
            console.log(data.Items[0]._farmName);
            this.setState(
              data.Items[0]
            );
            console.log(this.state);
          }
        });
    });
  }


  //componentWillUnmount() {
  //  var unsubscribe = this.props.dbRef.onSnapshot(() => {});
  //  unsubscribe();
  //}



  render() {

    return (
      <div>
		<div className='texts'>
		 	<p className='pagetitle'>{this.state.farmName} </p>
        	<h3> {this.state.growerName}</h3>
		</div>
      	<div>
      		<div className='growerContainer'>

		 			<img className='horizontalpic' alt="Farm View" src={this.state.farmPicture} />
					<div className="infobox">
						<div className='grower-page'>
						<table>
            			<tbody>

							<tr>
								<th>Country:</th>
								<td> {this.state.country}       </td>
							</tr>
							<tr>
								<th>Region:</th>
								<td> {this.state.region} </td>
							</tr>
							 <tr>
								<th>City/State:</th>
								<td>{this.state.cityState} </td>
							 </tr>
							 <tr>
								<th>Elevation:</th>
								<td>{this.state.elevation} masl </td>
							  </tr>
							  <tr>
								<th>Coffee Area:</th>
								<td>{this.state.areaCoffee} ha </td>
							  </tr>
							  <tr>
								<th>Total Area:</th>
								<td>{this.state.areaTotal} ha </td>
							  </tr>
							  <tr>
								<th>Production:</th>
								<td>{this.state.production} 60kg-bags/year</td>
							  </tr>
							  <tr>
								<th>Website:</th>
								<td>{this.state.website}</td>
							  </tr>
							  <tr>
								<th>Certifications:    </th>
								<td>{this.state.certifications}</td>
							  </tr>

						</tbody>
						</table>
						</div>
					</div>

		</div>

		<div className='texts'>
			<h2> {this.state.textWhyWeLike} </h2>
			<div className="row whatwedocontainer1">
				<div className="col-50 whatwedocontainer">
					{/*Change this later to load paragraphs from a collection*/}
					<div  dangerouslySetInnerHTML={{__html: this.state.textFarm}} />
        		</div>
				<div className="col-50 whatwedocontainer">
					<div className="textsnarrow">
						<p className="pagetitle2">Awards</p>
						<p>{this.state.awards}</p>
						<p className="pagetitle2">Beangood</p>
						<p>{this.state.beangood} </p>

					</div>
				</div>

			</div>
		</div>

		</div>

		<div className="row">
				<div className="col-50">
					<div className="row whatwedocontainer2">
						<p className="blocktitle">Meet the Growers</p>
	  					<p className="headline2"> {this.state.growerName} </p>
					</div>
				</div>
				<div className="col-50 whatwedocontainer3">
						<div className="textsnarrow ">
							{/*Change this later to load paragraphs from a collection*/}
							<i> <div dangerouslySetInnerHTML={{__html: this.state.textGrower}} /></i>
						</div>
				</div>
		</div>





	</div>

    );
  }
}

export default GrowerPage;



// WEBPACK FOOTER //
// ./src/components/GrowerPage.js